.ux-iws-data-controller-success-stories {
    display: block;

    @media only screen and (min-width: $desktop-s) {
        padding: 0 15px;
    }

    &__loader-container {
        width: 80%;
        margin: 0 auto;
    }

    ux-loader[variant="spinner"] {
        display: block;
    }

    *[data-ux-success-story-hidden] {
        display: none;
    }

    // specific for this template
    .ux-iws-teaser-image__text-wrapper {
        max-height: 120px;
        margin-top: auto;

        > *:first-child {
            align-self: flex-end;
        }
    }
}
